import React from "react";
import _ from "lodash";
import Highcharts from "highcharts";

class LegendControl extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      visibleMap: [],
    };

    this.handleToggle = this.handleToggle.bind(this);
    this.handleHover = this.handleHover.bind(this);
  }

  componentDidMount() {
    const { data } = this.props;
    const visibleMap = _.map(data, (d) => d);
    this.setState({ visibleMap });
  }

  handleToggle(name) {
    const { visibleMap } = this.state;
    const { chartRefs } = this.props;
    const isShow = !_.includes(visibleMap, name);
    const newMap = isShow
      ? [...visibleMap, name]
      : _.filter(visibleMap, (item) => item !== name);

    _.forEach(chartRefs, (ref) => {
      if (ref.current) {
        const chart = ref.current.ref.current.chart;
        if (chart) {
          _.forEach(chart.series, (s) => {
            if (chart.options.chart.type === "pie") {
              _.forEach(s.data, (d) => {
                const newVisible = _.indexOf(newMap, d.name) !== -1;
                d.setVisible(newVisible, false);
              });
            } else {
              const newVisible = _.indexOf(newMap, s.name) !== -1;
              s.setVisible(newVisible, false);
            }
          });
        }
      }
    });

    // Redraw all charts after toggle
    chartRefs.forEach(
      (ref) => ref.current && ref.current.ref.current.chart.redraw()
    );

    if (!isShow) this.handleHover(name, false);

    this.setState({ visibleMap: newMap });
  }

  handleHover(name, isHover) {
    const { visibleMap } = this.state;
    if (!_.includes(visibleMap, name)) return;

    const { chartRefs } = this.props;
    _.forEach(chartRefs, (ref) => {
      if (ref.current) {
        const chart = ref.current.ref.current.chart;
        if (chart) {
          if (chart.options.chart.type === "pie") {
            _.forEach(chart.series, (s) => {
              _.forEach(s.data, (d) => {
                if (isHover)
                  d.setState(name === d.name ? "hover" : "inactive", false);
                else d.setState("normal", false);
              });
            });
          } else {
            _.forEach(chart.series, (s) => {
              if (isHover) {
                s.update(
                  {
                    dataLabels: {
                      enabled: s.name === name,
                    },
                  },
                  false
                );
                s.setState(name === s.name ? "hover" : "inactive", false);
              } else {
                s.update(
                  {
                    dataLabels: {
                      enabled: false,
                    },
                  },
                  false
                );
                s.setState("normal", false);
              }
            });
          }
        }
      }
    });

    // Redraw all charts after toggle
    chartRefs.forEach(
      (ref) => ref.current && ref.current.ref.current.chart.redraw()
    );
  }

  render() {
    const { data } = this.props;
    const { visibleMap } = this.state;

    return (
      <>
        {data &&
          data.map((name, idx) => {
            return (
              <div
                className={`flex cursor-pointer text-sm ${
                  _.includes(visibleMap, name) ? "opacity-100" : "opacity-25"
                }`}
                onClick={() => this.handleToggle(name)}
                onMouseEnter={() => this.handleHover(name, true)}
                onMouseLeave={() => this.handleHover(name, false)}
                key={idx}
              >
                <span
                  className="pr-2"
                  style={{ color: Highcharts.getOptions().colors[idx] }}
                >
                  &#x25CF;
                </span>
                {name}
              </div>
            );
          })}
      </>
    );
  }
}

export default LegendControl;
